import React from "react";
import assetUrl from "../utils/assetUrl";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <div className="site-footer__logo" aria-hidden="true">
            <img src={assetUrl("/img/logoN.webp")} alt="BytaMed logo" width="96" height="96" loading="lazy" decoding="async" />
          </div>
          <h3>BytaMed</h3>
          <p>Trade and share things, skills, and experiences with people nearby.</p>
        </div>

        <div className="site-footer__links">
          <Link to="/">Home</Link>
          <Link to="/categories">Categories</Link>
          <Link to="/advice">Advice</Link>
          <Link to="/profiles">Profiles</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
        </div>

        <div className="site-footer__meta">
          <span>Local exchange platform</span>
          <span>Trusted local community</span>
          <span>© 2026 BytaMed</span>
        </div>
      </div>
    </footer>
  );
}
